import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { Badge } from '@leroy-merlin-br/backyard-react-ui'

import { Close } from 'checkout/components/Icons'

import { deleteStyles, iconColorStyles, tagStyles } from './styles'

const TagElement = styled('div')(tagStyles)
const Remove = styled('button')(deleteStyles, iconColorStyles)

const COLOR_MAP = {
  default: 'gray',
  success: 'green',
  danger: 'red',
  warning: 'yellow',
  loyalty: 'purple'
}

const Tag = ({ type, label, icon: Icon, isDisabled, onDelete }) => {
  const currentColor = isDisabled ? COLOR_MAP.default : COLOR_MAP[type]

  return (
    <Badge isLight color={currentColor}>
      <TagElement>
        {Icon && <Icon data-testid="tag-icon" />}
        {label}
        {onDelete && (
          <Remove type="button" data-testid="button-remove" color={type} onClick={onDelete} disabled={isDisabled}>
            <Close />
          </Remove>
        )}
      </TagElement>
    </Badge>
  )
}

Tag.propTypes = {
  type: PropTypes.oneOf(['default', 'success', 'danger', 'warning', 'loyalty'])
    .isRequired,
  label: PropTypes.string.isRequired,
  isDisabled: PropTypes.bool,
  onDelete: PropTypes.func,
  icon: PropTypes.func
}

Tag.defaultProps = {
  type: 'default',
  isDisabled: false
}

export default Tag
